import React, { useEffect, useState } from "react";
import { hideModal } from "../redux/features/oxygen/customModalSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { oxygenEligibilityResponse } from "../services/oxygenRetailServices";
import useCustomAlert from "./Alert2";

const OxygenWaitingModal = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customAlert = useCustomAlert();
  const precustomer = useSelector((state) => state?.precustomer?.precustomerData) || [];
  const [loading, setLoading] = useState(false);
  const isVisible = useSelector((state) => state.customModal?.isVisible);

  // 5 minutes = 300 seconds
  const [countdown, setCountdown] = useState(300);

  useEffect(() => {
    if (isVisible) {
      setCountdown(300);
    }
  }, [isVisible]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleProceed = async () => {
    setLoading(true);
    const res = await oxygenEligibilityResponse(precustomer?.precustomer?.precustomerId);
    console.log("Oxygen Eligibility Response:", res);
    if (res?.status === true) {
      dispatch(hideModal());
      navigate("/oxygen-details-form2");
    } else {
      customAlert.showToast("error", `${res?.message}` || "Failed to proceed");
    }
    setLoading(false);
  };

  return (
    <div className="card shadow-lg border-0 rounded-4 p-4 animate__animated animate__fadeIn">
      <div className="card-body text-center">
        {/* Countdown Circle */}
        <div
          className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-light shadow-sm"
          style={{
            width: "130px",
            height: "130px",
            border: countdown > 0 ? "5px solid #0d6efd" : "5px solid #198754",
            position: "relative",
          }}
        >
          <h2
            className={`fw-bold ${countdown > 0 ? "text-primary" : "text-success"} mb-0`}
            style={{ fontSize: "2rem" }}
          >
            {formatTime(countdown)}
          </h2>
        </div>

        {/* Title and Info */}
        <h4 className="text-info mb-3">
          {countdown > 0
            ? "Please wait while we process your request"
            : "You can now proceed!"}
        </h4>
        <p className="text-muted mb-4">
          {countdown > 0 ? "Your request is being processed. This may take a few minutes." : "Your request has been processed successfully."}
        </p>

        {/* Progress Bar */}
        {countdown > 0 && (
          <div className="progress mb-4" style={{ height: "8px" }}>
            <div
              className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
              role="progressbar"
              style={{ width: `${(1 - countdown / 300) * 100}%` }}
              aria-valuenow={countdown}
              aria-valuemin="0"
              aria-valuemax="300"
            />
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-3">
          <button
            className="btn btn-outline-secondary px-4 py-2 rounded-pill"
            onClick={() => dispatch(hideModal())}
          >
            Cancel
          </button>
          <button
            className={`btn ${
              countdown > 0 ? "btn-outline-primary" : "btn-success"
            } px-4 py-2 rounded-pill fw-bold`}
            onClick={handleProceed}
            disabled={countdown > 0}
          >
            {countdown > 0
              ? `Proceed (${formatTime(countdown)})`
              :loading ? "Please Wait..." : "Proceed"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OxygenWaitingModal;
